import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize, timer } from 'rxjs';
import { LoaderService } from './../services/loader.service';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);
  loaderService.show(); // Set loading to true
    
  const minWaitTime$ = timer(500);
  
  return next(req).pipe(
    finalize(() => {
      // Use a small timeout to ensure the 'hide' doesn't happen instantly
      setTimeout(() => loaderService.hide(), 500);
    }));
}